import Vue from 'vue';
import Router from 'vue-router';

import Magazine from './views/Magazine.vue';
import MagazineDetails from './views/MagazineDetails.vue';
import Payments from './views/Payments.vue';
import Profile from './views/Profile.vue';
import Login from './views/Login.vue';
import Signup from './views/Signup.vue';
import ForgetPassword from './views/ForgetPassword.vue';
import RecoverPassword from './views/RecoverPassword.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      redirect: '/signup',
    },
    {
      path: '/magazine',
      name: 'magazine',
      component: Magazine,
      meta: { full: true },
    },
    {
      path: '/payments',
      name: 'payments',
      component: Payments,
      meta: { full: true },
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: { full: true },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { full: false },
    },
    {
      path: '/magazine-details/:magazineId',
      name: 'magazine-details',
      component: MagazineDetails,
      meta: { full: true },
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup,
      meta: { full: false },
    }, {
      path: '/forget-password',
      name: 'forget-password',
      component: ForgetPassword,
      meta: { full: false },
    }, {
      path: '/recover-password',
      name: 'recover-password',
      component: RecoverPassword,
      meta: { full: false },
    },
  ],
});
